module.exports = __webpack_public_path__ + "img/水果特工队.36da65b7.png";